(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('DevisContrat', DevisContrat);

    DevisContrat.$inject = ['$http', 'DateUtils'];

    function DevisContrat($http, DateUtils) {
        return {
            query: query,
            get: get,
            save: save,
            transform: transform,
            downloadPdf: downloadPdf
        };

        function query(contractId) {
            return $http.get('api/contrats/' + contractId + '/devis').then(function(response) {
                angular.forEach(response.data || [], normalizeQuote);
                return response.data || [];
            });
        }

        function get(contractId, devisId) {
            return $http.get('api/contrats/' + contractId + '/devis/' + devisId).then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function save(contractId, devis) {
            return $http.post('api/contrats/' + contractId + '/devis', serializeQuote(devis)).then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function transform(contractId, devisId) {
            return $http.post('api/contrats/' + contractId + '/devis/' + devisId + '/transform').then(function(response) {
                return normalizeQuote(response.data);
            });
        }

        function downloadPdf(contractId, devisId) {
            return $http({
                url: 'api/contrats/' + contractId + '/devis/' + devisId + '/pdf',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/pdf'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition')) || ('devis-' + devisId + '.pdf')
                };
            });
        }

        function normalizeQuote(quote) {
            if (!quote) {
                return quote;
            }
            quote.dateDevis = DateUtils.convertLocalDateFromServer(quote.dateDevis);
            quote.validUntil = DateUtils.convertLocalDateFromServer(quote.validUntil);
            quote.pdfGeneratedDate = DateUtils.convertDateTimeFromServer(quote.pdfGeneratedDate);
            quote.transformedDate = DateUtils.convertDateTimeFromServer(quote.transformedDate);
            quote.acceptedDate = DateUtils.convertDateTimeFromServer(quote.acceptedDate);
            quote.createdDate = DateUtils.convertDateTimeFromServer(quote.createdDate);
            quote.lastModifiedDate = DateUtils.convertDateTimeFromServer(quote.lastModifiedDate);
            quote.lignes = quote.lignes || [];
            quote.remisesCommerciales = quote.remisesCommerciales || [];
            return quote;
        }

        function serializeQuote(devis) {
            var payload = angular.copy(devis || {});
            payload.dateDevis = DateUtils.convertLocalDateToServer(payload.dateDevis);
            payload.validUntil = DateUtils.convertLocalDateToServer(payload.validUntil);
            angular.forEach(payload.lignes || [], function(line) {
                delete line.$$hashKey;
            });
            angular.forEach(payload.remisesCommerciales || [], function(discount) {
                delete discount.$$hashKey;
            });
            return payload;
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return null;
            }
            var match = /filename=\"([^\"]+)\"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : null;
        }
    }
})();
